import { Body, Highlight, Link, Stack } from '@optimus-web/core';
import { getAppStandaloneDistributorUrl } from '../../modules/configuration/selectors';
import { useAppSelector } from '../../utils/redux';

export const DeprecationError = () => {
    const standaloneUrl = useAppSelector(getAppStandaloneDistributorUrl);

    return (
        <Stack
            desktopUp={{
                vertical: true,
            }}
            spacing="300"
            alignment="center"
            itemAlignment="center"
        >
            <Highlight align="center" size="large">
                Trying to place a booking? Follow the link to{' '}
                <Link target="_blank" rel="noreferrer" href={standaloneUrl}>
                    book now
                </Link>
            </Highlight>
            <Stack vertical>
                <Highlight align="center" size="small">
                    Hotels,
                </Highlight>
                <Body align="center">
                    To allow your guests to book from this site, please{' '}
                    <Link
                        target="_blank"
                        href="https://mews-systems.gitbook.io/booking-engine-guide/faq/mews-li-migration"
                        rel="noreferrer"
                    >
                        migrate now
                    </Link>
                </Body>
                <Body align="center">
                    The <strong>mews.li</strong> domain is <strong>no longer supported.</strong>
                </Body>
            </Stack>
        </Stack>
    );
};
